export default __webpack_public_path__ + "static/media/Dubai_loop.a23367d8.mp4";